module.exports = __webpack_public_path__ + "static/stickers-7c8b2d826803dedfc17d4d3dca924b5f.jpg";